<template>
  <div class="first-message">
    <div class="first-message__image">
      <div
        class="avatar-single avatar-single--circle avatar-single--shadow"
        v-bind:style="{ 'background-image': 'url(' + activeRoom.profile.avatar_url + '?p=avatar)' }"
      ></div>
    </div>
    <div v-if="!activeRoom.profile.is_admin" class="first-message__profile">
      <div class="profile-user">
        <div class="profile-user__name">
          {{ activeRoom.profile.name }} <span>{{ activeRoom.profile.age }} </span>
          <div v-if="activeRoom.profile.is_online" class="dot-online"></div>
        </div>
        <div class="profile-user__loc">Lives in {{ activeRoom.profile.address_city }}</div>

        <div class="loc__dis">
          <i class="demo-icon icon-pin"></i>{{ activeRoom.profile.location.distance }}
          <span>km</span>
        </div>
      </div>
    </div>
    <div v-if="!activeRoom.is_blocked && !activeRoom.profile.is_admin && messages.length" class="first-message__questions">
      <button v-for="message in messages" class="button button__fill button__fill--purple button--tight" @click="sendMessage(message)">{{ message }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyRoom',
  props: {
    activeRoom: Object | null,
  },
  data() {
    return {
      messages: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    sendMessage(message) {
      this.$emit('message', message);
    },
    getMessages() {
      let name = this.activeRoom.profile.name;
      this.$store.dispatch('invitationMessages/randomMessages', name).then((messages) => {
        this.messages = messages;
      });
    },
  },
  mounted() {
    if (this.globals.site.enabled_invitation_messages) {
      this.getMessages();
    }
  },
};
</script>
